var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.5C16.8358 17.5 16.5 17.8358 16.5 18.25C16.5 18.6642 16.8358 19 17.25 19H19.5C19.9142 19 20.25 18.6642 20.25 18.25C20.25 17.8358 19.9142 17.5 19.5 17.5H17.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.25 3C19.3211 3 21 4.67894 21 6.75V8.4325C22.1895 9.06124 23 10.3109 23 11.75V18.25C23 20.3211 21.3211 22 19.25 22H17.25C16.2654 22 15.3695 21.6206 14.7004 21H4.75C2.67894 21 1 19.3211 1 17.25V16.75C1 16.3358 1.33579 16 1.75 16H3V6.75C3 4.67894 4.67894 3 6.75 3H17.25ZM4.5 6.75C4.5 5.50736 5.50736 4.5 6.75 4.5H17.25C18.4927 4.5 19.5 5.50736 19.5 6.75V8.0082C19.4174 8.00276 19.334 8 19.25 8H17.25C15.1789 8 13.5 9.67889 13.5 11.75V16H4.5V6.75ZM13.5 18.25C13.5 18.6883 13.5752 19.109 13.7134 19.5H4.75C3.59186 19.5 2.63809 18.625 2.51373 17.5H13.5V18.25ZM17.25 20.5C16.0073 20.5 15 19.4927 15 18.25V11.75C15 10.5073 16.0073 9.5 17.25 9.5H19.25C20.4927 9.5 21.5 10.5073 21.5 11.75V18.25C21.5 19.4927 20.4927 20.5 19.25 20.5H17.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.c9b4e6aa01f9c616c603a544d9fc6b2e.svg";
export { ForwardRef as ReactComponent };